import React, { useEffect, useState, useCallback } from "react";
import { AddNewClass } from "../ClassesHelpers/AddNewClass";
import {
  fetchClassesOfDate,
  fetchClasses,
} from "../ClassesHelpers/fetchClassData";
import { getDate } from "../../basicHelper";
import { AddClassForNextWeek } from "../ClassesHelpers/AddClassForNextWeekHelper";
import { db } from "../../../config/firebase";
import { cityList, gymList, dbCalendar } from "../../../components/Databases";
import {
  collection,
  doc,
  getDocs,
  writeBatch,
  query,
} from "firebase/firestore";

/**
 * Displays Classes of the selectedDate in a Table
 * @param {Object} gymData - Contains information about the gym
 * @param {String} selectedDate - The date for which the classes are to be displayed (DD-MM-YYYY) format
 * @returns 
 */
const ClassesToday = ({ gymData, selectedDate }) => {
  const [classes, setClasses] = useState([]);
  const [showAddClassForm, setShowAddClassForm] = useState(false);
  const [isShowingClassesThisWeek, setIsShowingClassesThisWeek] =
    useState(false);

  useEffect(() => {
    const fetchClassesData = async () => {
      const classesData = await fetchClassesOfDate(gymData, selectedDate);
      setClasses(classesData);
    };

    fetchClassesData();
  }, [gymData, selectedDate]);

  const handleAddClassClick = () => {
    setShowAddClassForm(true);
  };

  const handleCloseForm = () => {
    setShowAddClassForm(false);
  };

  const loadClasses = useCallback(async () => {
    try {
      const data = await AddClassForNextWeek();
      const fetchedClasses = await fetchClasses(gymData);
      console.log(fetchedClasses, "fetchedClasses");

      const filteredClasses = [];

      // Filter classes based on the weekday
      data.forEach(({ date, weekDay }) => {
        fetchedClasses.forEach((cls) => {
          if (cls.days.includes(weekDay)) {
            filteredClasses.push({
              date, // Original date format
              day: weekDay,
              className: cls.className,
              level: cls.level || "N/A",
              trainer: cls.trainer,
              time: cls.classSchedule[weekDay],
              duration: cls.duration,
              totalSlots: cls.totalSlots,
              price: {
                member: cls.priceForMembers,
                nonMember: cls.priceForNonMembers,
              },
              attendees: [
                {
                  name: "John Doe", // HardCoded for now TODO
                  email: "k@g.com", // HardCoded for now TODO
                  paymentID: "123456", // HardCoded for now TODO
                },
              ],
            });
          }
        });
      });

      setClasses(filteredClasses);
      setIsShowingClassesThisWeek(true);
      const batch = writeBatch(db);
      for (const cls of filteredClasses) {
        // Format the date for document ID
        const formattedDate = cls.date
          .split("-")
          .reverse()
          .join("-")
          .split("-")
          .reverse()
          .join("-");

        // Define the collection reference for each date
        const classesRef = collection(
          db,
          cityList,
          gymData.city,
          gymList,
          gymData.gymName,
          dbCalendar,
          formattedDate, // This will create or reference a document for each date
          "Classes"
        );
        // Query to check if a class already exists for this date
        const classQuery = query(classesRef);
        const classSnapshot = await getDocs(classQuery);

        if (classSnapshot.empty) {
          // Create a document reference with an auto-generated ID
          const classDocRef = doc(classesRef);
          batch.set(classDocRef, cls);
        } else {
          console.log(`Class already exists for ${cls.date}. Skipping.`);
        }
      }
      await batch.commit();
    } catch (error) {
      console.error("Error loading classes:", error);
    }
  }, [gymData]);

  console.log("classes", classes);
    return (
      <div className="flex flex-col pt-2">
        <div className="flex flex-row justify-between items-center">
          {/* Added Responsiveness */}
          <p className="text-sm md:text-lg text-secondary font-bold text-left p-2">
            Classes {isShowingClassesThisWeek ? "This Week" : "Today"}:
          </p>
          <button
            onClick={loadClasses}
            className="text-tertiary text-sm lg:text-base font-bold bg-secondary py-2 px-2 md:px-4 mt-4 md:mt-2 rounded-lg shadow transition-colors my-2"
          >
            Add Classes for next Week
          </button>
          {showAddClassForm && (
            <AddNewClass
              onClassAdded={() =>
                fetchClassesOfDate(gymData, getDate()).then(setClasses)
              }
              onClose={handleCloseForm}
              gymData={gymData}
            />
          )}
        </div>

        {/* just added some styles for Responsiveness */}
        <div className="flex flex-col pb-4 rounded-2xl min-h-16 lg:min-h-24  border-secondary border-2 py-2 px-2 overflow-x-auto">
          <table className="min-w-full bg-tertiary">
            <thead>
              <tr className="text-xs sm:text-sm md:text-md lg:text-lg xl:text-xl">
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Date
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Class
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Level
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Instructor
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Time
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Duration
                </th>
                <th className="py-2 px-4 border-b-2 border-secondary text-center text-secondary">
                  Slots
                </th>
              </tr>
            </thead>
            <tbody>
              {classes.slice(0, 6).map((cls, index) => (
                <tr
                  key={index}
                  className="text-xs sm:text-sm md:text-md lg:text-md xl:text-md"
                >
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.date}
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.className}
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.level}
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.trainer}
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.time}
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {cls.duration} min
                  </td>
                  <td className="py-2 px-4 border-b text-center font-semibold">
                    {isShowingClassesThisWeek
                      ? `${cls.totalSlots - (cls.attendees?.length || 0)} / ${
                          cls.totalSlots
                        }`
                      : `${cls.totalSlots - (cls.attendees?.length || 0)} / ${
                          cls.totalSlots
                        }`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default ClassesToday;
